import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import IosQuestions from "../Components/IosQuestions";
import "./Theme.css";
import "./IntensityOfSign.css";

const IntensityOfSign = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  const [selectedRegions, setSelectedRegions] = useState([]);
  const [currentRegionIdx, setCurrentRegionIdx] = useState(0);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi.fetchBsaDetails()
      .then((res) => {
        const data = res.data.data || [];
        setSelectedRegions(data);
      })
      .catch(() => {});
  }, []);

  const handleSelect = (values) => {
    setFormData((prev) => ({ ...prev, ...values }));
  };

  const currentRegion = selectedRegions[currentRegionIdx];
  const isLast = currentRegionIdx === selectedRegions.length - 1;

  const handleNext = () => {
    if (currentRegionIdx < selectedRegions.length - 1) {
      setCurrentRegionIdx((i) => i + 1);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await lifestyleApi.logIntensitySigns({ goqiiUserId, formData });
      const qs = `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;
      navigate(`/scorad-intensity-symptoms?${qs}`);
    } catch (err) {
      // logIntensitySigns error
    } finally {
      setLoading(false);
    }
  };

  if (selectedRegions.length === 0) {
    return <div className="ios-loading">{t("common.loading")}</div>;
  }

  return (
    <section className="ios-page">
      <div className="ios-region-header">
        <h2 className="ios-region-name">{currentRegion?.name || `Region ${currentRegionIdx + 1}`}</h2>
        <span className="ios-region-counter">{currentRegionIdx + 1} / {selectedRegions.length}</span>
      </div>
      <IosQuestions handleSelect={handleSelect} selectedRegions={selectedRegions} questionKey={currentRegionIdx} />
      <div className="ios-nav-btns">
        {!isLast ? (
          <button className="ios-next-btn" onClick={handleNext}>{t("common.next")}</button>
        ) : (
          <button className="ios-done-btn" disabled={loading} onClick={handleSubmit}>
            {loading ? t("common.loading") : t("common.done")}
          </button>
        )}
      </div>
    </section>
  );
};

export default IntensityOfSign;
